var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 24,
    viewBox: "0 0 41 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_3032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9997 12.2838C40.9997 9.37857 39.5875 7.08618 36.8884 7.08618C34.1778 7.08618 32.5378 9.37857 32.5378 12.2611C32.5378 15.677 34.4739 17.4019 37.2528 17.4019C38.6081 17.4019 39.633 17.0955 40.4075 16.6643V14.3946C39.633 14.7804 38.7447 15.0187 37.6172 15.0187C36.5125 15.0187 35.5331 14.6329 35.4078 13.2938H40.9769C40.9769 13.1463 40.9997 12.5561 40.9997 12.2838ZM35.3736 11.2057C35.3736 9.92329 36.1595 9.38992 36.877 9.38992C37.5717 9.38992 38.3119 9.92329 38.3119 11.2057H35.3736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1416 7.08618C27.0255 7.08618 26.308 7.60821 25.9094 7.97136L25.7613 7.26776H23.2558V20.5L26.103 19.8986L26.1144 16.687C26.5244 16.982 27.128 17.4019 28.1302 17.4019C30.1688 17.4019 32.0252 15.7677 32.0252 12.1703C32.0138 8.87924 30.1346 7.08618 28.1416 7.08618ZM27.4583 14.9053C26.7863 14.9053 26.3877 14.6669 26.1144 14.3719L26.103 10.1616C26.3991 9.8325 26.8091 9.60554 27.4583 9.60554C28.4946 9.60554 29.2121 10.7631 29.2121 12.2497C29.2121 13.7704 28.506 14.9053 27.4583 14.9053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3378 6.41655L22.1968 5.80373V3.5L19.3378 4.10147V6.41655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1968 7.27905H19.3378V17.2089H22.1968V7.27905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2745 8.11871L16.0923 7.27893H13.632V17.2088H16.4796V10.4792C17.1516 9.60536 18.2906 9.76423 18.6437 9.88907V7.27893C18.2792 7.14274 16.9466 6.89308 16.2745 8.11871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5806 4.81641L7.80137 5.40653L7.78998 14.4966C7.78998 16.1762 9.05429 17.4132 10.74 17.4132C11.674 17.4132 12.3575 17.243 12.7333 17.0387V14.7349C12.3688 14.8825 10.5692 15.4045 10.5692 13.7249V9.69624H12.7333V7.27902H10.5692L10.5806 4.81641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88166 10.1616C2.88166 9.71902 3.24615 9.54879 3.84983 9.54879C4.71548 9.54879 5.80894 9.80981 6.6746 10.2751V7.60821C5.72921 7.23371 4.79522 7.08618 3.84983 7.08618C1.53762 7.08618 -6.10352e-05 8.28912 -6.10352e-05 10.2978C-6.10352e-05 13.43 4.32822 12.9306 4.32822 14.2811C4.32822 14.8031 3.87261 14.9734 3.23476 14.9734C2.28937 14.9734 1.08201 14.5875 0.125231 14.0655V16.7664C1.18452 17.2203 2.2552 17.4133 3.23476 17.4133C5.60392 17.4133 7.23272 16.2444 7.23272 14.213C7.22133 10.8312 2.88166 11.4326 2.88166 10.1616Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_3032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/Stripe.12077256e71255e978ebd9997ead37e8.svg";
export { ForwardRef as ReactComponent };